const appInfo = {
  title: "Signum PMS",
};
export default appInfo;
